import React, {MouseEventHandler, useState} from 'react'
import {Spinner} from '../template/Spinner'
import {twMerge} from 'tailwind-merge'
import APP_CONFIG from 'constants/clientConfigs'

export interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /**
     /**
     * Can be usable for controlling state of button loading
     */
  loading?: boolean
  onComplete?: Function | null
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined
  className?: string
  label?: string
  icon?: React.ReactNode
  loaderIcon?: React.ReactNode
  type?: 'button' | 'submit'
}

export const Button = ({
  loading: _loading = false,
  onComplete = null,
  onClick = undefined,
  onError = e => console.error('BUTTON', e),
  className = 'text-sm',
  label = '',
  children,
  icon,
  loaderIcon = <Spinner />,
  type = 'button',
  ...props
}: Props) => {
  const {focusVisibleColor, bgColor, hoverColor} =
    APP_CONFIG[process.env.REACT_APP_CLIENT_ID]
  const [loading, setLoading] = useState(_loading)

  const handleClick = async (e: any) => {
    setLoading(true)
    let r = null
    try {
      r = onClick
        ? await onClick(e)
        : await (async e =>
            type === 'submit'
              ? e.target.closest('form').dispatchEvent(new Event('submit'))
              : true)(e)
    } catch (e: any) {
      onError(e)
    }
    setLoading(false)
    if (onComplete && r) onComplete(r)
  }

  const textPaddingClass =
    (_loading || loading || icon) && (label || children) ? 'pr-1 -ml-1' : ''

  return (
    <React.Fragment>
      <button
        data-cy="Button"
        disabled={_loading || loading}
        {...props}
        onClick={handleClick}
        type={type}
        className={twMerge(
          `button flex w-full justify-center rounded-md ${bgColor} px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm ${hoverColor} focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${focusVisibleColor} ${className} ${
            _loading ? 'disabled' : ''
          }`
        )}>
        <span className={textPaddingClass}>
          {_loading || loading ? loaderIcon : icon}
        </span>
        {label || children}
      </button>
    </React.Fragment>
  )
}
